




































import { InOutKindsName } from "../../../../domain/workflow/kinds";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { Reception } from "../../../../domain/workflow/reception";
import { WorkflowCommonMixin } from "../../mixins";

@Component({
  components: {}
})
export default class ReceptionInformationView extends Mixins(WorkflowCommonMixin) {
  @Prop()
  reception: Reception;

  @Prop()
  isInOutTypeEnable: boolean;

  get receptionNumber(): string {
    return this.reception ? this.reception.receptionNumber : "";
  }

  get receptionDate(): Date {
    return this.reception ? this.reception.receptionDate : null;
  }

  get inputSection(): string {
    return this.reception ? (this.reception.inputSection ? this.reception.inputSection.name : "") : "";
  }

  get inOutType(): string {
    return this.reception ? (InOutKindsName.getDisplayName(this.reception.inOutType)) : "";
  }
}
